import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { SEARCH_SECTION_TABS } from '@Pages/QueryBuilder/QueryletConstants';
import { TabGroup, TabPanel } from '@els/els-react--tab-group';
import FieldsTab from '@Pages/QueryBuilder/SearchSection/SectionsTabs/FieldsTab';
import FormsTab from '@Pages/QueryBuilder/SearchSection/SectionsTabs/FormsTab';
import HistoryTab from '@Pages/QueryBuilder/SearchSection/SectionsTabs/HistoryTab';
import { searchSectionOpenedTab as searchSectionOpenedTabSelector } from '@Pages/QueryBuilder/QuerySelector';
import { setSearchSectionOpenedTab as setSearchSectionOpenedTabAction } from '@Pages/QueryBuilder/QueryletActions';

function SectionsTabs({ collectedFields, collectedForms, collectedHistoryItems, getForms, getHistoryItems, addToBuilder }) {
  const dispatch = useDispatch();
  const tabGroupRef = useRef();
  // Opened tab from Redux
  const searchSectionOpenedTab = useSelector(searchSectionOpenedTabSelector);
  const setSearchSectionOpenedTab = (_tabIndex) => dispatch(setSearchSectionOpenedTabAction(SEARCH_SECTION_TABS[_tabIndex]));

  useEffect(() => {
    const tabIndex = SEARCH_SECTION_TABS.indexOf(searchSectionOpenedTab);
    if (tabGroupRef.current) tabGroupRef.current.setActiveTab(tabIndex);
  }, [searchSectionOpenedTab]);

  return (
    <TabGroup
      ref={tabGroupRef}
      id="querybuilder-tabs"
      isControlled
      tabs={SEARCH_SECTION_TABS}
      hasDivider
      noDropdown
      onTabChange={setSearchSectionOpenedTab}>
      <TabPanel panelId="0">
        <FieldsTab nodes={collectedFields} addToBuilder={addToBuilder} />
      </TabPanel>
      <TabPanel panelId="1">
        <FormsTab nodes={collectedForms} getForms={getForms} addToBuilder={addToBuilder} />
      </TabPanel>
      <TabPanel panelId="2">
        <HistoryTab nodes={collectedHistoryItems} getHistoryItems={getHistoryItems} addToBuilder={addToBuilder} />
      </TabPanel>
    </TabGroup>
  );
}

SectionsTabs.propTypes = {
  collectedFields: PropTypes.array.isRequired,
  collectedForms: PropTypes.array.isRequired,
  collectedHistoryItems: PropTypes.array.isRequired,
  getForms: PropTypes.func.isRequired,
  getHistoryItems: PropTypes.func.isRequired,
  addToBuilder: PropTypes.func.isRequired,
};

export default SectionsTabs;
